import _ from "lodash";

import { PaperTooltip } from "@features/ui";

import { Column } from "./SmartTable";

export const showFirstN = (values: string[], n: number = 1) => (
  <div className="flex items-start gap-1">
    <div>{values.slice(0, n).join(", ")}</div>
    {values.length > n && (
      <PaperTooltip
        title={
          <ul className="list-disc list-inside">
            {values.map((v) => (
              <li key={v}>{v}</li>
            ))}
          </ul>
        }
      >
        <div className="text-xs py-px px-2 ml-1 mb-1 rounded bg-neutral-200 text-neutral-600 cursor-pointer hover:bg-neutral-300">
          +{values.length - n}
        </div>
      </PaperTooltip>
    )}
  </div>
);

export const showFirst = (value: string[] | undefined) =>
  showFirstN(value ?? [], 1);

export const insertIf = <T,>(condition: any, ...elements: Column<T>[]) =>
  condition ? elements : [];
